import React, { Fragment } from 'react'
import { Box, Typography } from '@mui/material'
import { AisleCell, GridCell } from '../types'
import { blockLabel } from '../config/constants'
import { formatOccupancy, formatUnits } from '../config/utils'
import { cellTooltipStyles as styles } from '../styles/CellTooltipContent.styles'

export { TOOLTIP_SX } from '../styles/CellTooltipContent.styles'

const NO_ZONE_COLORS: Map<string, string> = new Map()


export function CellTooltipContent({
  cell,
  rowLabel,
  brandColors,
  zoneColors = NO_ZONE_COLORS,
  showDetailHint = false,
}: {
  cell: GridCell | AisleCell
  rowLabel: string
  brandColors: Map<string, string>
  zoneColors?: Map<string, string>
  showDetailHint?: boolean
}) {
  const isGridCell = 'aisle' in cell
  const col = cell.column
  const rowId = isGridCell ? (cell as GridCell).aisle : (cell as AisleCell).level
  const zones = cell.zones ?? []
  const isBlocked = cell.blockType !== 'none'
  const hasCapacity = cell.maxCapacity > 0
  const isBrandFiltered = cell.brandStock !== null && cell.brandStock !== undefined
  const displayStock = cell.brandStock ?? cell.totalStock

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.headerLeft}>
          {zones.map((zone) => (
            <Box key={zone} sx={styles.zoneBadge(zoneColors.get(zone))}>
              {zone}
            </Box>
          ))}
          <Typography sx={styles.position}>
            {rowLabel} {rowId} — Col {col}
          </Typography>
        </Box>
        {isBlocked && <Box sx={styles.blockedBadge}>{blockLabel[cell.blockType]}</Box>}
      </Box>

      {!cell.isConfigured ? (
        <Typography sx={styles.unconfigured}>Sin posición configurada</Typography>
      ) : (
        <Fragment>
          <Box sx={styles.stockRow}>
            <Typography sx={styles.stockValue}>{formatUnits(displayStock)}</Typography>
            <Typography sx={styles.stockUnit}>uds. seleccionadas</Typography>
          </Box>
          {isBrandFiltered && (
            <Typography sx={styles.detailLine}>
              de {formatUnits(cell.totalStock)} uds. en las posiciones filtradas
            </Typography>
          )}
          {hasCapacity ? (
            <Fragment>
              <Typography sx={styles.detailLine}>
                Capacidad total: {formatUnits(cell.maxCapacity)} uds.
              </Typography>
              <Typography sx={styles.detailLine}>
                Ocupación: {formatOccupancy(cell.occupancyPct)}
              </Typography>
            </Fragment>
          ) : (
            <Typography sx={styles.detailLine}>Sin capacidad definida</Typography>
          )}
          <Box sx={styles.spacer} />

          {cell.brands.length > 0 && (
            <Fragment>
              <Box sx={styles.separator} />
              <Box sx={styles.brandList}>
                {cell.brands.map((b) => (
                  <Box key={b.name} sx={styles.brandRow}>
                    <Box sx={styles.brandLabel}>
                      <Box sx={styles.brandDot(brandColors.get(b.name))} />
                      <Typography sx={styles.brandName}>{b.name}</Typography>
                    </Box>
                    <Typography sx={styles.brandQty}>
                      {b.qty.toLocaleString()} uds
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Fragment>
          )}

          {showDetailHint && (
            <Fragment>
              <Box sx={styles.hintSeparator} />
              <Typography sx={styles.hint}>Doble clic para ver el detalle</Typography>
            </Fragment>
          )}
        </Fragment>
      )}
    </Box>
  )
}
